import { useEffect, useState } from "react";

const Darkmode = () => {
    const getSystemPreference = () =>
        window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

    const getInitialTheme = () => {
        // Check localStorage first
        const storedTheme = localStorage.getItem("theme");
        if (storedTheme) return storedTheme;
        // If no user preference, use system setting
        return getSystemPreference();
    };

    const [theme, setTheme] = useState(getInitialTheme);

    useEffect(() => {
        // Apply theme
        if (theme === "dark") {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
        localStorage.setItem("theme", theme);
    }, [theme]);

    useEffect(() => {
        // Listen for system theme changes
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

        const handleSystemThemeChange = (e) => {
            if (!localStorage.getItem("theme")) {
                setTheme(e.matches ? "dark" : "light");
            }
        };

        mediaQuery.addEventListener("change", handleSystemThemeChange);
        return () => mediaQuery.removeEventListener("change", handleSystemThemeChange);
    }, []);

    const handleThemeSwitch = () => {
        setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
        localStorage.setItem("theme", theme === "dark" ? "light" : "dark"); // Save choice
    };

    return (
        <div className="flex items-center justify-center">
            <button 
                onClick={handleThemeSwitch} 
                className="text-stone-900 dark:text-stone-100 bg-stone-200/50 dark:bg-stone-700/50 p-2.5 rounded-full hover:bg-stone-300/50 dark:hover:bg-stone-600/50 transition-colors shadow-sm flex items-center justify-center"
                aria-label="Toggle Dark Mode"
            >
                {theme === "dark" ? (
                    <span className="material-icons text-xl leading-none">light_mode</span>
                ) : (
                    <span className="material-icons text-xl leading-none">dark_mode</span>
                )}
            </button>
        </div>
    );
};

export default Darkmode;
